export const RiskLevels = [
    [
        { value: 1, label: '1 Low', bgColor: '#62D96B', color: '#FFFFFF' },
        { value: 2, label: '2 Low', bgColor: '#62D96B', color: '#FFFFFF' },
        { value: 3, label: '3 Low', bgColor: '#62D96B', color: '#FFFFFF' },
        { value: 4, label: '4 Moderate', bgColor: '#FFEE00', color: '#000000' },
        { value: 5, label: '5 Moderate', bgColor: '#FFEE00', color: '#000000' }
    ],
    [
        { value: 2, label: '2 Low', bgColor: '#62D96B', color: '#FFFFFF' },
        { value: 4, label: '4 Low', bgColor: '#62D96B', color: '#FFFFFF' },
        { value: 6, label: '6 Moderate', bgColor: '#FFEE00', color: '#000000' },
        { value: 8, label: '8 High', bgColor: '#FFC940', color: '#000000' },
        { value: 10, label: '10 High', bgColor: '#FFC940', color: '#000000' }
    ],
    [
        { value: 3, label: '3 Low', bgColor: '#62D96B', color: '#FFFFFF' },
        { value: 6, label: '6 Moderate', bgColor: '#FFEE00', color: '#000000' },
        { value: 9, label: '9 High', bgColor: '#FFC940', color: '#000000' },
        { value: 12, label: '12 High', bgColor: '#FFC940', color: '#000000' },
        { value: 15, label: '15 Extreme', bgColor: '#DB3737', color: '#FFFFFF' }
    ],
    [
        { value: 4, label: '4 Moderate', bgColor: '#FFEE00', color: '#000000' },
        { value: 8, label: '8 High', bgColor: '#FFC940', color: '#000000' },
        { value: 12, label: '12 High', bgColor: '#FFC940', color: '#000000' },
        { value: 16, label: '16 Extreme', bgColor: '#DB3737', color: '#FFFFFF' },
        { value: 20, label: '20 Extreme', bgColor: '#DB3737', color: '#FFFFFF' }
    ],
    [
        { value: 5, label: '5 Moderate', bgColor: '#FFEE00', color: '#000000' },
        { value: 10, label: '10 High', bgColor: '#FFC940', color: '#000000' },
        { value: 15, label: '15 Extreme', bgColor: '#DB3737', color: '#FFFFFF' },
        { value: 20, label: '20 Extreme', bgColor: '#DB3737', color: '#FFFFFF' },
        { value: 25, label: '25 Extreme', bgColor: '#DB3737', color: '#FFFFFF' }
    ]
];

export const RiskLevelsReduced = [
    { name: '1 Low', bgColor: '#62D96B', color: '#FFFFFF' },
    { name: '2 Low', bgColor: '#62D96B', color: '#FFFFFF' },
    { name: '3 Low', bgColor: '#62D96B', color: '#FFFFFF' },
    { name: '4 Low', bgColor: '#62D96B', color: '#FFFFFF' },
    { name: '4 Moderate', bgColor: '#FFEE00', color: '#000000' },
    { name: '5 Moderate', bgColor: '#FFEE00', color: '#000000' },
    { name: '6 Moderate', bgColor: '#FFEE00', color: '#000000' },
    { name: '8 High', bgColor: '#FFC940', color: '#000000' },
    { name: '9 High', bgColor: '#FFC940', color: '#000000' },
    { name: '10 High', bgColor: '#FFC940', color: '#000000' },
    { name: '12 High', bgColor: '#FFC940', color: '#000000' },
    { name: '15 Extreme', bgColor: '#DB3737', color: '#FFFFFF' },
    { name: '16 Extreme', bgColor: '#DB3737', color: '#FFFFFF' },
    { name: '20 Extreme', bgColor: '#DB3737', color: '#FFFFFF' },
    { name: '25 Extreme', bgColor: '#DB3737', color: '#FFFFFF' }
];

export const ProbabilityLevels = [{ id: 1, text: '1 Very unlikely' }, { id: 2, text: '2 Unlikely' }, { id: 3, text: '3 Possible' }, { id: 4, text: '4 Likely' }, { id: 5, text: '5 Very likely' }];

export const ConsequenceLevels = [{ id: 1, text: '1 Negligible' }, { id: 2, text: '2 Minor' }, { id: 3, text: '3 Moderate' }, { id: 4, text: '4 Significant' }, { id: 5, text: '5 Severe' }];

export const ControlTypes = [{ id: 1, name: "Preventive" }, { id: 2, name: "Detective" }, { id: 3, name: "Corrective" }];

export const MitigationStatus = [
    { id: 1, name: "Pending", color: '#669EFF' },
    { id: 2, name: "Started", color: '#62D96B' },
    { id: 3, name: "Warning", color: '#FFC940' },
    { id: 4, name: "Overdue", color: '#DB3737' },
    { id: 5, name: "Finished", color: '#BBBBBB' }
];